var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDrop = function SvgIconDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.774 157.558",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#83cbdb",
    d: "M72.572 1.706a5.97 5.97 0 0 0-8.358 0L18.68 46.7C11.741 54.1.239 69.465 0 89.956c-.158 16.863 7.243 34.031 20.254 47.121a66.81 66.81 0 0 0 96.271 0c13-13.078 20.4-30.258 20.244-47.121-.237-20.48-11.738-35.845-18.835-43.416Z"
  })));
};
export default SvgIconDrop;